<template>
  <v-dialog v-model="mostrado" max-width="800px" persistent scrollable>
    <v-form ref="form" v-model="formularioValido">
      <v-card>
        <v-card-title>
          <span class="text-h5">Importar Archivo CSV</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col col="12">
                <p>
                  Seleccione un archivo CSV para importar las cuentas. El formato del archivo debe ser el siguiente:
                </p>

                <pre>codigo,nombre,tipo_partida,descripcion,acepta_registro,tipo_oracle,oracle_id</pre>
                <pre>1.1.1.01.00.000,CAJA,Gastos,CAJA,0,Banco,219</pre>
                <pre>1.1.1.01.01.000,CAJA MONEDA NACIONAL,Gastos,CAJA MONEDA NACIONAL,0,Banco,419</pre>

                <p class="text-caption">
                  Donde:
                  
                  <ul>
                    <li><strong>codigo:</strong> Código de la cuenta (obligatorio)</li>
                    <li><strong>nombre:</strong> Nombre de la cuenta (obligatorio)</li>
                    <li><strong>tipo_partida:</strong> Tipo de partida (Gastos, Recursos, Contable Gastos, Contable Recursos) (obligatorio)</li>
                    <li><strong>descripcion:</strong> Descripción de la cuenta (opcional)</li>
                    <li><strong>acepta_registro:</strong> Indica si la cuenta acepta registro (1 para sí, 0 para no) (obligatorio)</li>
                    <li><strong>tipo_oracle:</strong> Tipo de cuenta en Oracle (opcional)</li>
                    <li><strong>oracle_id:</strong> ID de la cuenta en Oracle (opcional)</li>
                  </ul>
                </p>
              </v-col>

              <v-col cols="12">
                <v-file-input
                  v-model="archivo"
                  label="Seleccionar archivo CSV"
                  accept=".csv"
                  prepend-icon=""
                  prepend-inner-icon="mdi-file-delimited"
                  :rules="reglasValidacion"
                  required
                  show-size
                  outlined></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey darken-1" text :disabled="subiendo" @click="cerrar"> Cancelar </v-btn>

          <v-btn color="primary" :loading="subiendo" :disabled="!formularioValido || !archivo" @click="subir">
            Importar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <notifications group="notifications" position="top right" />
  </v-dialog>
</template>

<script>
import clasificador from '../services/clasificador';

export default {
  name: 'ModalFormularioImportarCuentas',
  data() {
    return {
      mostrado: false,
      formularioValido: false,
      archivo: null,
      subiendo: false,
      reglasValidacion: [
        (v) => !!v || 'El archivo es requerido',
        (v) => !v || v.name.endsWith('.csv') || 'El archivo debe ser CSV',
      ],
    };
  },
  methods: {
    async subir() {
      if (!this.$refs.form.validate()) return;

      this.subiendo = true;

      try {
        const archivoBase64 = await this.convertirArchivoABase64(this.archivo);
        const response = await clasificador.importar({ archivoBase64 });
        const data = response?.data;
        const mensaje = data?.mensaje || 'Archivo importado exitosamente';

        this.$notify({
          group: 'notifications',
          title: 'Importación Exitosa',
          text: mensaje,
          type: 'success',
        });
        this.$emit('importado', response.data);
        this.cerrar();
      } catch (error) {
        window.console.error('Error al importar el archivo:', error);
        const response = error.response;
        const data = response?.data;
        const mensaje = data?.mensaje || 'Error al importar el archivo';
        const errores = data?.errores;

        let mensajeErrores = '';

        Object.values(errores || {}).forEach((errorArray) => {
          errorArray.forEach((errorMsg) => {
            mensajeErrores += `- ${errorMsg}\n`;
          });
        });

        this.$notify({
          group: 'notifications',
          title: mensaje,
          text: mensajeErrores,
          type: 'error',
        });
      } finally {
        this.subiendo = false;
      }
    },
    convertirArchivoABase64(archivo) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(archivo);
        reader.onload = () => {
          const result = reader.result;
          const archivoBase64 = result.split(',')[1];

          resolve(archivoBase64);
        };
        reader.onerror = (error) => reject(error);
      });
    },
    abrir() {
      this.mostrado = true;
    },
    cerrar() {
      this.mostrado = false;
      this.archivo = null;
      this.$refs.form.reset();
    },
  },
};
</script>